<form id="{{cid}}-form" class="form {{#if validate_on_submit}}validate_on_submit{{/if}}" {{#if validate_on_submit}} novalidate {{/if}}">
  <div class="inputs {{inputs_class}}"></div>
  {{#if data.key}}
    <div class="form__submit-wrapper">
      <input type="submit" {{#if data.submit.class}}class="{{data.submit.class}}{{/if}}" {{#if data.submit.text}}value="{{pt data.submit.text}}"{{/if}} />
      {{#if data.submit.sprite}}
        <div class="sprite"></div>
      {{/if}}
      {{#if allow_reset}}
        <input type="button" id="reset-form" value="{{t 'reset'}}" class="{{#if reset_button_class}}{{reset_button_class}}{{else}}btn btn-default{{/if}} hidden" role="button">
      {{/if}}
    {{/if}}
  </div>
</form>

{{#if buttons}}
  <div class="buttons">
    <div class="btn-group">
      {{#each buttons}}
        <button class="{{button_class}}" id="{{id}}" data-execute="{{exec}}">{{t text}}</button>
      {{/each}}
    </div>
  </div>
{{/if}}
